// components/BoletoParceladoConfig.js
// Reutilizável em CriarEvento.js e EditarEvento.js
//
// Props:
//   config   = { ativo, parcelasDisponiveis }
//   onChange = (novaConfig) => void
//
// A taxa por parcela vem automaticamente da taxa de boleto cadastrada no painel.
// O campo diasMinimoParaEvento foi removido — o limite de parcelas é calculado
// automaticamente no checkout com base nos dias até o evento (dias / 30).

import React from "react"

const OPCOES_PARCELAS = [2, 3, 4, 6, 12]

export default function BoletoParceladoConfig({ config = {}, onChange }) {
  const {
    ativo = false,
    parcelasDisponiveis = [],
  } = config

  const set = (campo, valor) => onChange({ ...config, [campo]: valor })

  const toggleParcela = (n) => {
    const atual = parcelasDisponiveis.includes(n)
      ? parcelasDisponiveis.filter((x) => x !== n)
      : [...parcelasDisponiveis, n].sort((a, b) => a - b)
    set("parcelasDisponiveis", atual)
  }

  return (
    <div className="boleto-parcelado-config">

      {/* Toggle principal */}
      <div className="bp-toggle-row">
        <label className="bp-toggle-label">
          <input
            type="checkbox"
            checked={ativo}
            onChange={(e) => set("ativo", e.target.checked)}
          />
          <span className="bp-toggle-track" />
          <span className="bp-toggle-text">Permitir boleto parcelado neste evento</span>
        </label>
      </div>

      {ativo && (
        <div className="bp-body">

          {/* Seleção de parcelas máximas */}
          <div className="bp-grupo">
            <label className="bp-label">Parcelas máximas disponíveis</label>
            <p className="bp-hint">
              Selecione até quantas vezes o vaqueiro poderá parcelar. O sistema
              limita automaticamente de acordo com os dias até o evento
              (ex: se faltam 60 dias, máximo de 2x, independente do que for marcado aqui).
            </p>
            <div className="bp-parcelas-grid">
              {OPCOES_PARCELAS.map((n) => (
                <button
                  key={n}
                  type="button"
                  className={`bp-parcela-btn ${parcelasDisponiveis.includes(n) ? "ativo" : ""}`}
                  onClick={() => toggleParcela(n)}
                >
                  {n}x
                </button>
              ))}
            </div>
            {parcelasDisponiveis.length === 0 && (
              <p className="bp-alerta">⚠️ Selecione ao menos uma opção de parcelamento.</p>
            )}
          </div>

          {/* Info sobre a taxa */}
          <div className="bp-info-taxa">
            <span className="bp-info-icon">💡</span>
            <span>
              A taxa cobrada por parcela é a mesma taxa de boleto cadastrada no painel
              <strong> Gerenciar Taxas</strong>. Não é necessário configurá-la aqui.
            </span>
          </div>

          {/* Preview */}
          {parcelasDisponiveis.length > 0 && (
            <div className="bp-preview">
              <p className="bp-label">Exemplo de parcelamento para uma senha de R$ 300,00:</p>
              <p className="bp-hint" style={{ marginBottom: 8 }}>
                * A taxa de boleto é somada automaticamente em cada parcela.
              </p>
              <div className="bp-preview-grid">
                {parcelasDisponiveis.map((n) => (
                  <div key={n} className="bp-preview-card">
                    <span className="bp-preview-parcelas">{n}x</span>
                    <span className="bp-preview-valor">R$ {(300 / n).toFixed(2)}</span>
                    <span className="bp-preview-label">+ taxa boleto</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )
}